export enum AssistantTabs {
  Assistant = 'Assistant',
  SmartMatches = 'Smart Matches',
  DataIntegrations = 'Integrations',
}
